/* Coordinate existing theme drawers with documented Rebuy show/hide events. */
(function () {
  'use strict';
  function createCoordinator({ document, getSmartCart }) {
    let cartOpen = false, listening = false;
    function closeHeaderOverlays(event) {
      document.querySelectorAll('header-drawer').forEach(drawer => {
        const details = drawer.mainDetailsToggle;
        if (!details?.hasAttribute('open') || typeof drawer.closeMenuDrawer !== 'function') return;
        drawer.closeMenuDrawer(event, false);
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.header__search details-modal, details-modal.header__search').forEach(modal => {
        if (modal.isOpen?.()) modal.close(false);
      });
    }
    function show(event) { cartOpen = true; closeHeaderOverlays(event); }
    function hide() { cartOpen = false; }
    function click(event) {
      if (event.target.closest('#cart-icon-bubble')) closeHeaderOverlays(event);
      const summary = event.target.closest('summary');
      const drawer = summary?.closest('header-drawer');
      if (cartOpen && drawer && summary === drawer.mainDetailsToggle?.querySelector('summary')) {
        const cart = getSmartCart();
        if (typeof cart?.hide === 'function') cart.hide();
      }
    }
    function start() {
      if (listening) return;
      listening = true;
      document.addEventListener('click', click, true);
      document.addEventListener('rebuy:smartcart.show', show);
      document.addEventListener('rebuy:smartcart.hide', hide);
    }
    function destroy() {
      document.removeEventListener('click', click, true);
      document.removeEventListener('rebuy:smartcart.show', show);
      document.removeEventListener('rebuy:smartcart.hide', hide);
      listening = false;
    }
    return { start, destroy };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = createCoordinator;
  else if (!document.documentElement.dataset.dsOverlaySync) {
    document.documentElement.dataset.dsOverlaySync = 'ready';
    createCoordinator({ document, getSmartCart: () => window.Rebuy?.SmartCart }).start();
  }
}());
